export default __webpack_public_path__ + "static/media/KZ.T.13.2490 black.7c766053.svg";